import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { ChartDataset, ChartOptions, ChartType } from 'chart.js';
import { saveAs } from 'file-saver';
import { UserAudit } from 'src/app/core/models/userAudit';
import { AuthService } from 'src/app/core/services/auth.service';
import { PositionsService } from 'src/app/core/services/positions.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-last-position',
  templateUrl: './last-position.component.html',
  styleUrls: ['./last-position.component.scss'],
  providers: [DatePipe],
})
export class LastPositionComponent implements OnInit, AfterViewInit {
  constructor(
    private positionService: PositionsService,
    public datePipe: DatePipe,
    public toastService: ToastService,
    private authService: AuthService
  ) {
    this.userAudit = new UserAudit(
      this.authService.currentUserValue,
      'packets/lastposition'
    );
  }
  public positionEvent: Event[] = [];
  public positionPrepared: any[] = [];
  public positionEventJson: any[] = [];
  serialsWithoutResult: string = '';

  public serial: string = '';

  headers: string[] = [];

  public circularProgressiveWait: boolean = false;

  public collapseAllCardEvents: boolean = true;
  public textHighlight: string = '';

  public getScreenWidth: any;
  public getScreenHeight: any;

  public prettyEvent: string = '1';

  lat: number = 51.673858;
  lng: number = 7.815982;
  zoom: number = 4;

  showMap: boolean = false;
  simplified: boolean = true;
  markers: google.maps.Marker[] = [];

  // Graph Line
  public lineChartDataBattery: ChartDataset[] = [];
  public lineChartLabelsBattery: string[] = [];
  public lineChartFilterDetectionP2PBattery: boolean = true;
  public lineChartFilterOriginP2PBattery: boolean = false;

  public lineChartData: ChartDataset[] = [];
  public lineChartLabels: string[] = [];
  public lineChartOptions: ChartOptions = {
    responsive: true,
    scales: {},
  };
  public lineChartFilterDetectionP2PGsmGps: boolean = true;
  public lineChartFilterOriginP2PGsmGps: boolean = false;

  public lineChartColors: any[] = [
    {
      borderColor: 'black',
      backgroundColor: 'rgba(255,0,0,0.3)',
    },
  ];
  public lineChartLegend = true;
  public lineChartType: ChartType = 'line';
  public lineChartPlugins = [];

  // Graph Line
  graphField: string[] = [];
  graphFieldSelect: string = 'tipo_evento';
  // TableCountEventModal
  public countEventTable: countEventTable[] = [];
  public tableCountEventHTML: string[] = [];
  // End TableCountEventModal

  // Graph
  public barChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'end',
        font: {
          size: 20,
        },
      },
    },
  };
  public barChartLabels: string[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataset[] = [];
  public heightGraph = '300px';
  public tableCountEventHTMLString = '';
  public countEvent = {};

  userAudit: UserAudit;
  options: google.maps.MapOptions = {
    zoom: 3.5,
    center: { lat: -14, lng: -54 },
    zoomControl: true,
    streetViewControl: true,
    disableDefaultUI: false,
  };

  loader = new Loader({
    apiKey: environment.googleMaps.key,
    version: 'weekly',
  });
  maps: any;

  ngAfterViewInit() {
    this.initializeMap();
  }

  private async initializeMap() {
    await this.loader.importLibrary('core');
    const { Map } = (await google.maps.importLibrary(
      'maps'
    )) as google.maps.MapsLibrary;

    this.maps = new Map(
      document.getElementById('map') as HTMLElement,
      this.options
    );
  }

  ngOnInit(): void {
    console.log('');
  }

  dostuff(b64Data: string): Uint8Array {
    const byteCharacters = atob(b64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return byteArray;
  }

  epochToDateTime(eventJson: any) {
    eventJson.data_hora_evento = this.datePipe.transform(
      new Date(eventJson.data_hora_evento).toUTCString(),
      'dd-MM-yyyy HH:mm:ss'
    )!;
    eventJson.data_hora_recebimento = this.datePipe.transform(
      new Date(eventJson.data_hora_recebimento).toUTCString(),
      'dd-MM-yyyy HH:mm:ss'
    )!;
    eventJson.data_hora_armazenamento = this.datePipe.transform(
      new Date(eventJson.data_hora_armazenamento).toUTCString(),
      'dd-MM-yyyy HH:mm:ss'
    )!;
    if (eventJson.data_hora_temperatura) {
      // data_hora_temperatura vem do backend em segundos (epoch), diferente dos demais campos que vem em milissegundos
      eventJson.data_hora_temperatura = this.datePipe.transform(
        new Date(eventJson.data_hora_temperatura * 1000).toUTCString(),
        'dd-MM-yyyy HH:mm:ss'
      )!;
    }

    return eventJson;
  }

  searchLastPosition(): void {
    this.initMap();
    this.serialsWithoutResult = '';
    this.positionEventJson = [];
    this.markers = [];
    this.barChartData = [];
    this.barChartLabels = [];
    this.countEventTable = [];
    this.tableCountEventHTML = [];
    this.lineChartData = [];
    this.lineChartLabels = [];
    this.markers = [];
    this.tableCountEventHTMLString = '';
    this.circularProgressiveWait = true;
    var serialList = this.serial.replace(' ', '').split(';');
    serialList = serialList.filter((v, i, a) => a.indexOf(v) === i);

    var serialListWithoutLastPosition = serialList;
    this.positionService
      .getLastPositionJson(serialList, this.userAudit)
      .subscribe(
        (response: any) => {
          if (response.length > 0 && this.positionEventJson.length == 0) {
            var positionEvent = response;
            positionEvent
              .slice()
              .reverse()
              .forEach((event: any) => {
                if (event != '') {
                  let eventJsonParseDate: any = this.epochToDateTime(
                    JSON.parse(event)
                  );
                  try {
                    serialListWithoutLastPosition =
                      serialListWithoutLastPosition.filter((obj) => {
                        return (
                          obj !== eventJsonParseDate.rastreador.numero_serie
                        );
                      });
                  } catch {}

                  try {
                    eventJsonParseDate.revgeo.bairro = decodeURI(
                      eventJsonParseDate.revgeo.bairro
                    );
                    eventJsonParseDate.revgeo.logradouro = decodeURI(
                      eventJsonParseDate.revgeo.logradouro
                    );
                    eventJsonParseDate.revgeo.municipio = decodeURI(
                      eventJsonParseDate.revgeo.municipio
                    );
                  } catch (error) {}
                  if (this.showMap) {
                    this.setMakerPosition(eventJsonParseDate);
                  }
                  this.positionEventJson.push(eventJsonParseDate);
                }
              });

            if (this.showMap) {
              this.maps.setCenter({
                lat: this.positionEventJson[0].gps.latitude,
                lng: this.positionEventJson[0].gps.longitude,
              });
              this.maps.setZoom(this.zoom);
            }
            this.circularProgressiveWait = false;
            if (serialListWithoutLastPosition.length > 0) {
              this.serialsWithoutResult =
                serialListWithoutLastPosition.join(';');
              this.toastService.show(
                'Verificar na aba sem resultado: ' +
                  serialListWithoutLastPosition.length +
                  ' sem resultados.',
                {
                  classname: 'bg-warning text-center text-white',
                  delay: 10000,
                }
              );
            } else {
              this.toastService.show('Sucesso', {
                classname: 'bg-success text-center text-white',
                delay: 2500,
              });
            }
          }
          this.circularProgressiveWait = false;
        },
        (error: HttpErrorResponse) => {
          this.toastService.show('Erro ao pesquisar - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 5000,
          });
          this.circularProgressiveWait = false;
        }
      );
  }

  setMakerPosition(positionEvent: any) {
    var color = 'blue';

    if (positionEvent.flags.posicao_online) {
      if (positionEvent.gps.fixado) {
        color = 'blue';
      } else {
        color = 'black';
      }
    } else if (positionEvent.gps.fixado) {
      color = 'red';
    } else {
      color = 'purple';
    }
    let proa = positionEvent.gps.proa;
    let icon = '';
    if (proa == -1) {
      icon = `../../../../assets/images/arrows/${color}_circle.png`;
    } else {
      if (
        Number(positionEvent.gps.proa) < 0 ||
        Number(positionEvent.gps.proa) > 360
      ) {
        proa = 0;
      }
      icon = `../../../../assets/images/arrows/${color}_arrow_${String(
        Number(proa).toFixed(0)
      )}.png`;
    }

    let marker: any;
    let infowindow: any;
    if (positionEvent.origem_mensagem == 'LORA_P2P') {
      marker = new google.maps.Marker({
        position: {
          lat: positionEvent.p2p.latitude,
          lng: positionEvent.p2p.longitude,
        },
        icon: '../../../../assets/images/carrinho-p2p.png',
        title: `<p><span style="color: #ff0000;"><strong>${positionEvent.dataHoraEvento}</strong></span></p>`,
        label: `${this.positionEventJson.length + 1}`,
      });

      infowindow = new google.maps.InfoWindow({
        content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span"><strong>${
          positionEvent.rastreador.numero_serie
        }</strong></span></p>
        <p><span style="color: #ff0000;"><strong>${
          positionEvent.data_hora_evento
        }</strong></span></p>
        <p><strong>Evento:</strong> ${positionEvent.p2p.motivo ?? ''}</p>
        <p><strong>Rssi:</strong> ${positionEvent.p2p.rssi ?? ''}</p>
        <p><strong>SNR:</strong> ${positionEvent.p2p.snr ?? ''}</p>
        <p><strong>Lat:</strong> ${positionEvent.p2p.latitude}</p>
        <p><strong>Long:</strong> ${positionEvent.p2p.longitude}</p>
        <p><strong>Dispositivo que detectou:</strong> ${
          positionEvent.p2p.numero_serie ?? ''
        }</p>
        <p><strong>OrigemMensagem:</strong> ${
          positionEvent.origem_mensagem ?? ''
        }</p>
        </div>
        `,
      });
    } else if (positionEvent.origem_mensagem == 'LORA_WAN') {
      marker = new google.maps.Marker({
        position: {
          lat: positionEvent.p2p.latitude,
          lng: positionEvent.p2p.longitude,
        },
        icon: '../../../../assets/images/tower.png',
        title: `<p><span style="color: #ff0000;"><strong>${positionEvent.dataHoraEvento}</strong></span></p>`,
      });

      infowindow = new google.maps.InfoWindow({
        content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span"><strong>${
          positionEvent.rastreador.numero_serie
        }</strong></span></p>
        <p><span style="color: #ff0000;"><strong>${
          positionEvent.data_hora_evento
        }</strong></span></p>
        <p><strong>Evento:</strong> ${positionEvent.p2p.motivo ?? ''}</p>
        <p><strong>Rssi:</strong> ${positionEvent.p2p.rssi ?? ''}</p>
        <p><strong>SNR:</strong> ${positionEvent.p2p.snr ?? ''}</p>
        <p><strong>Lat:</strong> ${positionEvent.p2p.latitude}</p>
        <p><strong>Long:</strong> ${positionEvent.p2p.longitude}</p>
        <p><strong>OrigemMensagem:</strong> ${
          positionEvent.origem_mensagem ?? ''
        }</p>
        </div>
        `,
      });
    } else {
      marker = new google.maps.Marker({
        position: {
          lat: positionEvent.gps.latitude,
          lng: positionEvent.gps.longitude,
        },
        icon: { url: icon, anchor: new google.maps.Point(12, 12) },
        title: `<p><span style="color: #ff0000;"><strong>${positionEvent.dataHoraEvento}</strong></span></p>`,
        label: `${this.positionEventJson.length + 1}`,
        optimized: true,
      });

      infowindow = new google.maps.InfoWindow({
        content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span"><strong>${positionEvent.rastreador.numero_serie}</strong></span></p>
        <p><span style="color: #ff0000;"><strong>${positionEvent.data_hora_evento}</strong></span></p>
        <p><strong>Evento:</strong> ${positionEvent.tipo_evento}</p>
        <p><strong>Lat:</strong> ${positionEvent.gps.latitude}</p>
        <p><strong>Long:</strong> ${positionEvent.gps.longitude}</p>
        <p><strong>Sat:</strong> ${positionEvent.gps.numero_satelites}</p>
        <p><strong>GpsFix:</strong> ${positionEvent.gps.fixado}</p>
        <p><strong>Ignicao:</strong> ${positionEvent.flags.ignicao}</p>
        <p><strong>PosicaoOnline:</strong>${positionEvent.flags.posicao_online}</p>
        <p><strong>Velocidade:</strong> ${positionEvent.gps.velocidade}</p>
        </div>
        `,
      });
    }
    marker.addListener('click', () => {
      infowindow.open({
        anchor: marker,
        shouldFocus: false,
      });
    });
    marker.setMap(this.maps);

    this.markers.push(marker);
  }

  openInfoWindowMap(id: number): void {
    google.maps.event.trigger(this.markers[id], 'click');
  }

  setCenterPositionOnMapAndOpenInfoBox(index: number): void {
    this.maps.setCenter({
      lat: this.positionEventJson[index].gps.latitude,
      lng: this.positionEventJson[index].gps.longitude,
    });
    this.maps.setZoom(14);
    this.openInfoWindowMap(index);
  }

  getFields(event: any): any {
    Object.entries(event).forEach((item: any) => {
      let key: string[] = [];
      item.forEach((itemAux: any) => {
        switch (typeof itemAux) {
          case 'string':
            if (itemAux == item[0]) key.push(itemAux);
            if (
              itemAux == item[0] &&
              typeof item[1] != 'object' &&
              !this.headers.includes(itemAux)
            )
              this.headers.push(itemAux);
            break;
          case 'object':
            Object.entries(itemAux).forEach((subItem: any) => {
              subItem.forEach((subItemAux: any) => {
                switch (typeof subItemAux) {
                  case 'string':
                    if (
                      subItemAux == subItem[0] &&
                      typeof subItem[1] != 'object' &&
                      !this.headers.includes(item[0] + '.' + subItemAux)
                    ) {
                      this.headers.push(item[0] + '.' + subItemAux);
                    }
                    break;
                  //@ts-ignore
                  case 'object':
                    Object.entries(subItemAux).forEach((subsubItem: any) => {
                      subsubItem.forEach((subsubItemAux: any) => {
                        switch (typeof subsubItemAux) {
                          case 'string':
                            if (
                              subsubItemAux == subsubItem[0] &&
                              typeof subsubItem[1] != 'object' &&
                              !this.headers.includes(
                                item[0] + '.' + subItem[0] + '.' + subsubItemAux
                              )
                            ) {
                              this.headers.push(
                                item[0] + '.' + subItem[0] + '.' + subsubItemAux
                              );
                            }
                            break;
                          default:
                            break;
                        }
                      });
                    });
                  default:
                    break;
                }
              });
            });
            break;
          default:
            break;
        }
      });
    });
    this.headers.forEach((item) => {
      if (!this.headers.includes(item)) {
        this.headers.push(item);
      }
    });
  }

  //Export Excel
  exportExcel() {
    this.headers = [];
    this.positionEventJson.forEach((event) => {
      this.getFields(event);
    });
    let headersAux = [
      'tipo_evento',
      'data_hora_evento',
      'data_hora_recebimento',
      'data_hora_armazenamento',
    ];
    this.headers.forEach((item: any) => {
      let notExist =
        headersAux.findIndex((header: any) => {
          return header == item;
        }) > -1
          ? false
          : true;
      if (notExist) {
        headersAux.push(item);
      }
    });
    let json: Object[] = [];
    this.positionEventJson.forEach((event: any) => {
      let jsonAux: string[] = [];

      headersAux.forEach((header: any) => {
        let field = header.split('.');
        let eventAux = event;
        let eventValue = '"' + header + '":""';
        field.forEach((item: any) => {
          if (item in eventAux) {
            if (item == field[field.length - 1]) {
              eventValue =
                '"' + header + '":"' + eventAux[item].toString() + '"';
            }
            eventAux = eventAux[item];
          }
        });
        jsonAux.push(eventValue);
      });
      json.push(JSON.parse('{' + jsonAux.join(',') + '}'));
    });

    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(json);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(
        excelBuffer,
        `ultimaPosicao_${this.datePipe.transform(
          new Date(),
          'yyyy-MM-ddTHH:mm:ss'
        )}`
      );
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let currentDate = new Date();
    let month: number = currentDate.getMonth() + 1;
    let day: number = currentDate.getDate();
    let year: number = currentDate.getFullYear();
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(data, fileName + EXCEL_EXTENSION);
    });
  }
  initMap() {
    this.initializeMap();
    this.markers.forEach((item: google.maps.Marker) => {
      item.setMap(null);
    });
    this.markers = [];
  }

  getFieldEvents() {
    this.graphField = [];
    this.headers = [];
    this.positionEventJson.forEach((event) => {
      this.getFields(event);
    });
    this.headers = this.headers.sort((obj1, obj2) => {
      if (obj1 > obj2) {
        return 1;
      } else if (obj1 < obj2) {
        return -1;
      }
      return 0;
    });
  }
  selectTabAnalytics() {
    if (this.tableCountEventHTMLString == '') {
      this.getFieldEvents();
      this.countEventGraphBarMountAndTable(this.graphFieldSelect);
    }
  }
  countEventGraphBarMountAndTable(fieldSelect: string) {
    this.barChartData = [];
    this.barChartLabels = [];
    this.countEventTable = [];
    this.lineChartDataBattery = [];
    this.lineChartLabelsBattery = [];
    this.lineChartData = [];
    this.lineChartLabels = [];
    this.tableCountEventHTMLString = '';
    var tableCountEventHTML = [
      '<div> <table class="table table-fit table-hover">',
    ];
    var field = fieldSelect.split('.');
    var eventTypeAux: string[] = [];
    var dateHeaders: string[] = [];
    var eventsHeaders: string[] = [];
    this.positionEventJson.forEach((event: any) => {
      let eventAux = event;
      var eventString: string = '';
      field.forEach((item: any) => {
        if (item in eventAux) {
          if (item == field[field.length - 1]) {
            eventString = eventAux[item].toString();
          }
          eventAux = eventAux[item];
        }
      });

      var dateEvent: string = event.data_hora_evento.split(' ')[0];

      var indexDate = this.countEventTable.findIndex((valueDateObj) => {
        return valueDateObj.date == dateEvent;
      });
      if (indexDate > -1) {
        var indexEvent = this.countEventTable[indexDate].events.findIndex(
          (valueEventObj: any) => {
            return valueEventObj.name.toString() == eventString;
          }
        );
        if (indexEvent > -1) {
          this.countEventTable[indexDate].events[indexEvent].qtd =
            this.countEventTable[indexDate].events[indexEvent].qtd + 1;
        } else {
          if (eventsHeaders.indexOf(eventString) < 0) {
            eventsHeaders.push(eventString);
          }
          this.countEventTable[indexDate].events.push({
            name: eventString,
            qtd: 1,
          });
        }
      } else {
        if (eventsHeaders.indexOf(eventString) < 0) {
          eventsHeaders.push(eventString);
        }
        dateHeaders.push(dateEvent);
        this.countEventTable.push({
          date: dateEvent,
          events: [{ name: eventString, qtd: 1 }],
        });
      }

      if (
        eventTypeAux.filter((value) => {
          return value == eventString;
        }).length > 0
      ) {
        this.barChartData
          .filter((label) => {
            return label.label == eventString;
          })
          .map((obj) => {
            var a = Number(obj.data[0]);
            obj.data[0] = a + 1;
          });
      } else {
        eventTypeAux.push(eventString);

        this.barChartData.push({
          data: [1],
          label: eventString,
        });
      }
    });

    this.barChartLabels.push(this.positionEventJson[0].rastreador.numero_serie);

    tableCountEventHTML.push(
      '<thead class="table-primary"><tr ><th scope="col">#</th>'
    );
    dateHeaders.forEach((date) => {
      tableCountEventHTML.push(
        '<th scope="col"><div><strong>' + date + '</strong></div></th>'
      );
    });
    tableCountEventHTML.push(
      '<th scope="col"><div><strong> Total</strong> </div></th>'
    );

    tableCountEventHTML.push('</tr></thead>');

    var sumEventDate: number[] = [];
    var sumTotal = 0;

    try {
      eventsHeaders = eventsHeaders.sort((obj1, obj2) => {
        if (obj1 > obj2) {
          return 1;
        } else if (obj1 < obj2) {
          return -1;
        }
        return 0;
      });
    } catch (error) {}

    eventsHeaders.forEach((event) => {
      var sumEvent = 0;
      var dateIndexSumEvent = 0;
      tableCountEventHTML.push('<tr>');
      tableCountEventHTML.push(
        '<th scope="row"><strong>' + event + '<strong></th>'
      );
      dateHeaders.forEach((date) => {
        if (sumEventDate.length < dateHeaders.length) {
          sumEventDate.push(0);
        }
        var indexDate = this.countEventTable.findIndex((dateObj: any) => {
          return dateObj.date == date;
        });

        var indexEvent = this.countEventTable[indexDate].events.findIndex(
          (eventObj: any) => {
            return eventObj.name == event;
          }
        );
        if (indexEvent > -1) {
          tableCountEventHTML.push(
            '<td>' +
              this.countEventTable[indexDate].events[indexEvent].qtd +
              '</td>'
          );

          sumEvent =
            sumEvent + this.countEventTable[indexDate].events[indexEvent].qtd;
          sumEventDate[dateIndexSumEvent] =
            sumEventDate[dateIndexSumEvent] +
            this.countEventTable[indexDate].events[indexEvent].qtd;
          sumTotal =
            sumTotal + this.countEventTable[indexDate].events[indexEvent].qtd;
        } else {
          tableCountEventHTML.push('<td>' + 0 + '</td>');

          sumEventDate[dateIndexSumEvent] = sumEventDate[dateIndexSumEvent] + 0;

          sumTotal = sumTotal + 0;
        }
        dateIndexSumEvent = dateIndexSumEvent + 1;
      });
      tableCountEventHTML.push('<td><strong>' + sumEvent + '</strong></td>');
      tableCountEventHTML.push('</tr>');
    });

    tableCountEventHTML.push(
      '<tr><th scope="row"><strong> Total</strong> </th>'
    );
    sumEventDate.forEach((dateCount) => {
      tableCountEventHTML.push('<td>' + dateCount + '</td>');
    });
    tableCountEventHTML.push('<td><strong>' + sumTotal + '</strong></td>');

    tableCountEventHTML.push('</tr>');

    tableCountEventHTML.push('</table></div>');

    tableCountEventHTML.forEach((value) => {
      this.tableCountEventHTMLString = this.tableCountEventHTMLString + value;
    });
  }
}

interface countEventTable {
  date: string;
  events: [{ name: string; qtd: number }];
}
